/**
 * Bootstrap
 */
import Dropdown from 'bootstrap/js/dist/dropdown';
import Collapse from 'bootstrap/js/dist/collapse';
import Alert from 'bootstrap/js/dist/alert';

/**
 * Swiper
 */
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination, Parallax } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay, Parallax, EffectFade]);
window.Swiper = Swiper;

/*import enableAnchorTop from './public/anchor-top.ts';
import enableNavigation from './public/navigation.ts';
enableAnchorTop();
enableNavigation();*/

import enablePhotoSwipeLightbox from './public/photo-swipe-lightbox.ts';
enablePhotoSwipeLightbox();

import Picker from 'pickerjs';

//
function roundMinutes(date) {
    const m = date.getMinutes();
    const rounded = Math.floor(m / 15) * 15;
    date.setMinutes(rounded);
    date.setSeconds(0);
    return date;
}

var now = roundMinutes(new Date());

if(document.getElementById('date')) {
    var inputDate = document.getElementById('date');
    var pickerDate = new Picker(inputDate, {
        format: 'DD/MM/YYYY',
        text: {
            title: 'Scegli il giorno di partenza',
            cancel: 'Annulla',
            confirm: 'OK'
        }
    });
}
if(document.getElementById('time')) {
    var inputTime = document.getElementById('time');
    var pickerTime = new Picker(inputTime, {
       format: 'HH:mm',
        text: {
            title: 'Scegli l\'ora di partenza',
            cancel: 'Annulla',
            confirm: 'OK',
        }
    });
}

if(document.getElementById('time_arrive')) {
    var inputTimeArrive = document.getElementById('time_arrive');
    var pickerTimeArrive = new Picker(inputTimeArrive, {
        format: 'HH:mm',
        text: {
            title: 'Scegli l\'ora di arrivo',
            cancel: 'Annulla',
            confirm: 'OK'
        }
    });
}


//import.meta.glob(['../img/**']);

// import './vendor/theme.js';
// For W3CMS themes, customize as needed
import './w3cms/theme.js';

/**
 * For TypiCMS’s Places module
 */
// import initMap from './public/map';
// window.initMap = initMap;
